export const getEventId = () => {
  return notefit_config.event_id;
}

export const getEventSlug = () => {
  return notefit_config.event_slug;
}

export const getCompanyMembershipId = () => {
  return typeof connectspace_config != "undefined" ? connectspace_config.company_membership_id : false;
}

export const graphColorList = ["#0F62DC",
                               "#C717B2",
                               "#F10088",
                               "#3ADFBB",
                               "#358EFF",
                               "#F63C4C",
                               "#FA7215",
                               "#5791E6",
                               "#D75CC8",
                               "#F54DAB",
                               "#74E8CF",
                               "#74D0E3",
                               "#71AFFF",
                               "#F87682",
                               "#FB9C5A"];
